module.exports = __webpack_public_path__ + "static/media/service-area.1e4dc49f.JPG";